import React from "react";
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Box,
    Button,
    Grid,
    Typography,
    TextField,
    Slider,
} from "@mui/material";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";

const FormatAndLayout = () => {
    const theme = localStorage.getItem("theme");
    const { slideCount, setSlideCount, additionalInstructions, setAdditionalInstructions, themeStyle, setThemeStyle, typographyStyle, setTypographyStyle, layoutStyle, setLayoutStyle, titleStyle, setTitleStyle } = useWorkspace();
    // NUMBER OF SLIDES
    const SlideCountOptions = [
        { code: "auto", label: "Auto" },
        { code: "5", label: "5 Slides" },
        { code: "8", label: "8 Slides" },
        { code: "12", label: "12 Slides" },
        { code: "15", label: "15 Slides" }
    ];

    // THEME / COLOR SCHEME
    const ThemeOptions = [
        { code: "light", label: "Light Theme" },
        { code: "dark", label: "Dark Theme" },
        { code: "corporateBlue", label: "Corporate Blue" },
        { code: "modernPurple", label: "Modern Purple" },
        { code: "gradient", label: "Gradient Theme" }
    ];

    // TYPOGRAPHY STYLE
    const TypographyOptions = [
        { code: "sans", label: "Sans-serif (Modern)" },
        { code: "serif", label: "Serif (Classic)" },
        { code: "rounded", label: "Rounded Fonts" },
        { code: "bold", label: "Bold Headings" },
        { code: "minimal", label: "Minimal Typography" }
    ];

    // SLIDE LAYOUT STYLE
    const SlideLayoutOptions = [
        { code: "visualHeavy", label: "More Visuals" },
        { code: "bulletPoints", label: "More Bullet Points" },
        { code: "balanced", label: "Balanced Layout" },
        { code: "paragraph", label: "Paragraph Style" },
        { code: "imageLeftTextRight", label: "Image Left, Text Right" }
    ];

    // TITLE SLIDE STYLE
    const TitleSlideOptions = [
        { code: "clean", label: "Clean & Minimal" },
        { code: "bold", label: "Bold Title Style" },
        { code: "corporate", label: "Corporate Layout" },
        { code: "imageBackground", label: "Image Background" },
        { code: "iconStyle", label: "Icon-Based Style" }
    ];


    const buttonStyle = (selected, isActive) => ({
        backgroundColor: isActive ? "#3a3f69" : "#30355f",
        color: "white",
        border: "1px solid #565b85",
        "&:hover": {
            backgroundColor: isActive ? "#3a3f69" : "#40446e",
        },
        mx: 0.5,
    });

    const handleSliderChange = (event, newValue) => {
        setSlideCount(newValue);
    };

    const customTextFieldStylesForInvalid = () => {
        return {
            "& .MuiInputLabel-root": {
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
                letterSpacing: "0.5px",
                color: "rgba(255, 255, 255, 0.80)",
                "&.Mui-focused": {
                    color: "rgba(255, 255, 255, 0.80)",
                },
            },
            "& .MuiInputBase-input": {
                color: "#FFFFFF",
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.80)",
                },
                "&:hover fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.80)",
                },
                "&.Mui-focused fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.80) ",
                },
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
                color: "rgba(255, 255, 255, 0.80) ",
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(255, 255, 255, 0.80) ",
            },
        };
    };




    return (
        <div>
            <Box>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
                    Number of Slides
                </Typography>

                {/* <Grid container spacing={1}>
                        {SlideCountOptions.map((item) => (
                        <Grid item key={item.code}>
                            <Button
                            onClick={() => setSlideCount(item.code)}
                            sx={buttonStyle(slideCount, slideCount === item.code)}
                            >
                            {item.label}
                            </Button>
                        </Grid>
                        ))}
                    </Grid> */}
                <Slider
                    value={slideCount}
                    onChange={handleSliderChange}
                    min={1}
                    max={15}
                    step={1}
                    valueLabelDisplay="auto"
                    marks={[
                        { value: 1, label: "1" },
                        { value: 15, label: "15" }
                    ]}
                    sx={{
                        maxWidth: "500px",
                        color: "white",
                        "& .MuiSlider-thumb": {
                            backgroundColor: "white",
                            border: "2px solid white",
                        },
                        "& .MuiSlider-track": {
                            backgroundColor: "white",
                        },
                        "& .MuiSlider-rail": {
                            backgroundColor: "gray",
                        },
                        "& .MuiSlider-markLabel": {
                            color: "white",        // label text color
                            fontSize: "14px",
                        },
                    }}
                />
            </Box>

            <Box mt={3}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500,}}>
                    Additional Instructions
                </Typography>

                <TextField multiline
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    value={additionalInstructions}
                    onChange={(e) => setAdditionalInstructions(e.target.value)}
                    sx={() => customTextFieldStylesForInvalid()}
                    style={{
                        width: "500px",
                        marginTop: "30px",
                        // height: "56px",
                        color: "#FFFFFF",
                        // backgroundColor: "#232746",
                        borderRadius: "8px",
                        boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                        placeholderfontsize: "16px",
                    }}
                    InputProps={{
                        style: {
                            height: "112px", 
                            padding: "20px 14px", 
                            alignItems: "flex-start", 
                            overflow: "auto",
                        },
                        inputProps: {
                                maxLength: 300, 
                                },
                    }}
                    InputLabelProps={{
                        style: {
                            whiteSpace: "normal", 
                            // overflow: "visible", // Ensures the entire label is visible
                        },
                    }}
                />

            </Box>

            {/* <Box mt={3}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
                    Theme / Color Scheme
                </Typography>

                <Grid container spacing={1}>
                    {ThemeOptions.map((item) => (
                    <Grid item key={item.code}>
                        <Button
                        onClick={() => setThemeStyle(item.code)}
                        sx={buttonStyle(themeStyle, themeStyle === item.code)}
                        >
                        {item.label}
                        </Button>
                    </Grid>
                    ))}
                </Grid>
                </Box> */}


            {/* <Box mt={3}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
                    Typography Style
                </Typography>

                <Grid container spacing={1}>
                    {TypographyOptions.map((item) => (
                    <Grid item key={item.code}>
                        <Button
                        onClick={() => setTypographyStyle(item.code)}
                        sx={buttonStyle(typographyStyle, typographyStyle === item.code)}
                        >
                        {item.label}
                        </Button>
                    </Grid>
                    ))}
                </Grid>
                </Box> */}

            {/* <Box mt={3}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
                    Slide Layout Preference
                </Typography>

                <Grid container spacing={1}>
                    {SlideLayoutOptions.map((item) => (
                    <Grid item key={item.code}>
                        <Button
                        onClick={() => setLayoutStyle(item.code)}
                        sx={buttonStyle(layoutStyle, layoutStyle === item.code)}
                        >
                        {item.label}
                        </Button>
                    </Grid>
                    ))}
                </Grid>
                </Box> */}

            {/* <Box mt={3}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, mb: 2 }}>
                        Title Slide Style
                    </Typography>

                    <Grid container spacing={1}>
                        {TitleSlideOptions.map((item) => (
                        <Grid item key={item.code}>
                            <Button
                            onClick={() => setTitleStyle(item.code)}
                            sx={buttonStyle(titleStyle, titleStyle === item.code)}
                            >
                            {item.label}
                            </Button>
                        </Grid>
                        ))}
                    </Grid>
                    </Box> */}



        </div>
    )
}

export default FormatAndLayout